var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{attrs:{"name":"list","tag":"div","css":false},on:{"before-enter":_vm.handleBeforeEnter,"enter":_vm.handleEnter,"after-enter":_vm.handleAfterEnter}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }